import { Button } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AlertsContext } from "providers/alerts";
import { useContext, useState } from "react";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";

const ItemTemplate = ({ item }: { item: any }) => {
  const { showError } = useContext(AlertsContext);

  const [downloading, setDownloading] = useState(false);

  const downloadTemplate = async () => {
    try {
      setDownloading(true);
      const { signedUrl } = await apiRequest("/supabase/loan_items/download", {
        id: item.id,
      });
      window.open(signedUrl);
    } catch (err) {
      showError({
        title: "Download Failed",
        description: getErrorMessage(err),
      });
    } finally {
      setDownloading(false);
    }
  };

  if (!(item.checklist_item || {}).template_path) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      size="sm"
      mb="20px"
      onClick={downloadTemplate}
      isLoading={downloading}
      leftIcon={<FontAwesomeIcon icon={["far", "download"]} />}
    >
      Download Template
    </Button>
  );
};

export default ItemTemplate;
